import React, { Component } from 'react'
import axios from 'axios';
import dayjs from 'dayjs';

import './IdSetting.scss';
import { GetBaseUrl } from '@/utils/ConfigHelper'
import { mode } from 'webconfig';

import BlockUserListDialog from './BlockUserListDialog'
import EmailNotification from './EmailNotification/EmailNotification';
import OneBtnDialog from '../Common/OneBtnDialog/OneBtnDialog';
import i18n from '../i18n';
import Notice from '../UserPage/PaymentPoints/Payment/Notice/Notice';
import DeleteAccountDialog from './DeleteAccountDialog/DeleteAccountDialog';
import Uploading from '@/Common/Uploading/Uploading'
import CopyToClipboard from 'copy-to-clipboard'
import { ErrorText } from '@/Common/Button';

import { connect } from 'react-redux'
import { REDUX_ACTION } from '../Redux/action'
import { ReduxBinding } from '@/Redux/instance'
import { Logout, UpdateCurrentCredit } from '../Interface'
import BusinessAccount from './BusinessAccountDialog/BusinessAccount';
import { Trans } from 'react-i18next'

class IdSetting extends Component {
  state = {
    currentpassword: '',
    newpassword: '',
    confirmpassword: '',
    isDialogOpened: false,
    dialogType: "reWritePassword",
    isDialogOpeneDeleteAccount: false,
    clickChangeName: false,
    isNoticeDialogopened: false,
    isOpenBusinessAccountDialog: false,
    isBlockDialogOpen: false,
    // viewUserId : this.props.currentUser.userId,
    //업로드 창 띄우는 state
    denySnsEmail: true,
    //서버에서 보내주는 정보
    createdAt: undefined,
    viewUserId: undefined, // 서버에서 displayName으로 알려줌
    enableEmailNotifications: undefined,
    activatePermanently: undefined,
    userEmail: undefined,
    paymentWay: "",
    active: false,// 환불 or 취소 사유를 적지 않으면 비활성화 시키는 state,
    refundReason: ``,
    isUnscheduling: false,
    isRefunding: false,
    date: null
  };

  async componentDidMount() {
    try {
      const token = localStorage.getItem("token")
      const result = await axios.get(
        `${GetBaseUrl()}/api/user/settingsdata`,
        { headers: { Authorization: `Bearer ${token}` } }
      )

      if (result.status === 200) {
        const { createdAt, displayName, Email, enableEmailNotifications, activatePermanently } = result.data

        this.setState({
          createdAt,
          viewUserId: displayName,
          userEmail: Email,
          enableEmailNotifications,
          activatePermanently
        })
      }
    }
    catch (e) {
      //if (e.response.status == 401) alert(`어드민 로그인이 필요합니다.`)
    }

    const today = new Date()
    const date = `${today.getFullYear()}.${(today.getMonth() + 1)}.${today.getDate()}`
    this.setState({ date })
  }

  sendGARefundEvent = async (paymentId) => {
    if (mode === 'stage') {
      // ReactGA.plugin.execute('ec', 'setAction', 'refund', {
      //   id: paymentId
      // })

      // ReactPixel.trackCustom("refund", {
      //   content_type: 'product',
      //   contents: [{ id: productInfo.productId, paymentId, quantity: 1 }]
      // }
      // )
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: 'tag_transaction',
          ecommerce: {
            refund: {
              actionField: { id: paymentId }
            }
          }
        })
      }
    }
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  changeEmailHandleChange = (e) => {
    this.setState({ enableEmailNotifications: e.target.value })

    // setState시에 enableEmailNotifications값이 바뀌지 않고 바로 넘어가서 실시간 값이 아님.
    const token = localStorage.getItem("token")
    axios.post(
      `${GetBaseUrl()}/api/user/set_email_notifications_option`,
      { value: e.target.value === "true" },
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .then(res => {
        if (this.state.enableEmailNotifications === "true") {
          this.setState({ isDialogOpened: true, dialogType: "denyEmail" })
        }
      })
      .catch(error => console.log(error))
  }

  changePassword = async () => {
    const { currentpassword, newpassword, confirmpassword } = this.state;
    if (!currentpassword.trim() || !newpassword.trim() || !confirmpassword.trim()) return
    if (currentpassword.length === 0 || newpassword.length === 0 || confirmpassword.length === 0) {
      return this.setState({ isDialogOpened: true, dialogType: "requiredPassword" })
    }

    if (!this.isValidPassword(newpassword)) {
      return this.setState({ isDialogOpened: true, dialogType: "requiredPassword" })
    }
    if (newpassword.trim() !== confirmpassword.trim()) {
      this.setState({
        isDialogOpened: true,
        dialogType: "reWritePassword",
        // isDialogOpened: true,
        // dialogType: 'DifferentPassword',
        currentpassword: '',
        newpassword: '',
        confirmpassword: '',
        //비밀번호 입력 란 초기화
      })
      return
    }

    const token = localStorage.getItem('token')
    const result = await axios.post(
      `${GetBaseUrl()}/api/user/pw_change`,
      {
        pw: currentpassword.trim(),
        new_pw: newpassword.trim(),
        check_pw: confirmpassword.trim()
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .catch(error => {
        //console.log('비밀변호 변경에 실패했습니다. 정확한 비밀번호를 입력해주세요.');
        this.setState({
          isDialogOpened: true,
          dialogType: "failPassword",
          currentpassword: '',
          newpassword: '',
          confirmpassword: '',
          //비밀번호 입력 란 초기화
        })
        return
      })

    if (result && result.data && result.data.message === 'success') {
      this.setState({
        isDialogOpened: true,
        dialogType: "successPassword",
        currentpassword: '',
        newpassword: '',
        confirmpassword: '',
        //비밀번호 입력 란 초기화
      })
      //console.log('비밀번호 변경을 완료했습니다.');
    }
  };

  handleClickCopyInviteUserLink = () => {
    const { currentUser } = this.props
    if (!currentUser) return

    CopyToClipboard(`${GetBaseUrl()}/invite?id=${currentUser.shareId}`)
    alert(i18n.t("idsetting.invite.user.alert"))
  }

  dialogHandleClose = () => this.setState({ isDialogOpened: false })

  clickChangeName = async (e) => {
    const { viewUserId } = this.state
    const { currentUser } = this.props

    if (viewUserId.length < 2) {
      this.setState({ isDialogOpened: true, dialogType: "requestMinText" })
      return
    }

    try {
      if (currentUser.displayName !== viewUserId) {
        const token = localStorage.getItem('token')
        const result = await axios.post(
          `${GetBaseUrl()}/api/user/displayName_change`,
          { displayName: viewUserId },
          { headers: { Authorization: `Bearer ${token}` } }
        )

        this.setState({ isDialogOpened: true, dialogType: "successName" })

        const { displayName } = result.data
        currentUser.userId = displayName
        currentUser.displayName = displayName
        ReduxBinding(REDUX_ACTION.USER, currentUser)
      }
    }
    catch (error) {
      if (error && error.response && error.response.data && error.response.data.message === 'fail') {
        alert(i18n.t("signup.enter.duplicated.nickname"))
        this.setState({ viewUserId: currentUser.displayName })
      }
    }
    this.setState({ clickChangeName: false })
  }

  clickedChangeName = (e) => this.setState({ clickChangeName: true })

  handleWithdraw = () => {
    // alert("철회")
  }

  renderPaymentMode = () => {
    const { paymentMode, pointTicket, value } = this.props

    let productName
    let expiredDate
    let isCancelable = true;
    const isInAppPurchase = paymentMode ? paymentMode.isInAppPurchase : false;
    if (paymentMode && paymentMode.product && paymentMode.product.productName) {
      productName = paymentMode.product.productName[value] || paymentMode.product.productName['en']
      expiredDate = paymentMode.expiredDate;
      isCancelable = paymentMode.isCancelable;
    }
    else if (pointTicket && pointTicket.productName) {
      productName = `[POINT] ${pointTicket.productName[value] || pointTicket.productName['en']}`
      expiredDate = pointTicket.expiredDate
    }

    if (!productName || !expiredDate) return i18n.t("payment.coupon.nopayment.text")

    return (
      <div className="payment-row">
        <span
          style={{ color: "#252525", "font-weight": "bold" }}
        >{`${productName} (~${new Date(expiredDate)
          .toISOString()
          .substr(2, 8)
          .replace(/-/gi, ".")})`}</span>
        {(!isInAppPurchase && !isCancelable) ? (
          <div className="payment-cancel-box">{i18n.t('idsetting.recurring.payment.cancel')}</div>
        ) : null}
      </div>
    );
  }

  renderPaymentModeButton = () => {
    const { currentUser, paymentMode } = this.props
    const type = currentUser ? currentUser.type : null
    let isCancelable, isUnschedulable
    if (paymentMode) {
      isCancelable = paymentMode.isRefundable
      isUnschedulable = paymentMode.isCancelable
    }
    return (
      <>
        {
          // 비즈니스 마스터 계정으로 만든 자식 계정이 아닌 경우
          paymentMode && type !== 'business_partial' ?
            <>
            {/* 취소가 가능한 경우 (환불 가능 기준 달성) */}
            {
              isCancelable ? 
              <div>
                <p style={{ width: "100%" }} onClick={this.openDiaogRefund}><Trans i18nKey="payment.request.refund" /></p>
              </div> : 
              null
            }

            {/* 구독 취소가 가능한 경우 */}
            {
              isUnschedulable ? 
              <div>
                <p style={{ width: "100%" }} onClick={this.openDialogCancel}><Trans i18nKey="payment.cancel.subscribe" /></p>
              </div> : 
              null
            }

            {/* isAgency : 비즈니스 요금제 여부, business_partial : 비즈니스 자식 계정 타입 */}
            {
              (paymentMode.product ? paymentMode.product.isAgency : false) &&
              <div onClick={this.handleClickBusinessAccount}>
                <p>{i18n.t("web.business.account.management")}</p>
              </div>
            }
            </>
          :
          null
        }
      </>
    )
  }

  onClickRefund = async () => {
    if (this.state.active && window.confirm(i18n.t("payment.ask.again.refund"))) {
      this.setState({ isNoticeDialogopened: false, isRefunding: true })

      try {
        const { paymentMode: { _id } } = this.props
        await this.cancelPayment(_id, this.state.refundReason)
        alert(i18n.t(`payment.success.refund.text`))
        this.setState({ isRefunding: false })
        if (this.props.refreshUserData) {
          this.props.refreshUserData()
          this.componentDidMount()
          UpdateCurrentCredit()
        }
        else this.props.history.push({ pathname: '/home' })
      }
      catch (e) {
        this.setState({
          isDialogOpened: true,
          dialogType: "failRefund",
          isRefunding: false
        })
      }
    }
  }

  onClickCancel = async () => {
    if (this.state.active && window.confirm(i18n.t("payment.ask.again.subscribe"))) {
      this.setState({ isNoticeDialogopened: false, isUnscheduling: true })

      try {
        const { paymentMode: { scheduledPayments } } = this.props

        // for문으로 await 돌리는 이유는 동시에 돌아가서 DB 충돌 안나게끔.
        for (let i = 0; i < scheduledPayments.length; i++) {
          const paymentId = scheduledPayments[i]
          await this.unschedulePayment(paymentId, this.state.refundReason)
        }
        alert(i18n.t("payment.success.cancel.subscribe"))
        this.setState({ isUnscheduling: false })
        if (this.props.refreshUserData) {
          this.props.refreshUserData()
          this.componentDidMount()
        }
        else this.props.history.push({ pathname: '/home' })
      }
      catch (e) {
        this.setState({
          isDialogOpened: true,
          dialogType: "failUnschedule",
          isUnscheduling: false
        })
      }
    }
  }

  cancelPayment = async (paymentId, reason) => {
    const token = localStorage.getItem("token")
    const cancelPaymentResult = await axios.patch(
      `${GetBaseUrl()}/apis/payments/refund`,
      { paymentId, reason },
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .catch(err => {})

    if (cancelPaymentResult && cancelPaymentResult.status === 200) this.sendGARefundEvent(paymentId)
    else throw `ERR_FAILED`
  }

  unschedulePayment = async (paymentId, reason) => {
    const token = localStorage.getItem("token")
    const unschedulePaymentResult = await axios.patch(
      `${GetBaseUrl()}/apis/payments/unschedule`,
      { paymentId, reason },
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .catch(err => {})

    if (!unschedulePaymentResult || unschedulePaymentResult.status !== 200) throw `ERR_FAILED`
  }

  openDiaogRefund = () => this.setState({ isNoticeDialogopened: true, paymentWay: "refund" })
  openDialogCancel = () => this.setState({ isNoticeDialogopened: true, paymentWay: "cancel" })

  onRefundReasonChanged = e => {
    this.checkUserWrited(e.target.value)
    this.setState({ refundReason: e.target.value })
  }

  checkUserWrited = (text) => {
    if (text.length > 1) this.setState({ active: true })
    else this.setState({ active: false })
  }

  handleDeleteAccount = () => () => {
    if (window.confirm(i18n.t("idsetting.deleteaccount.ask.again"))) {
      const token = localStorage.getItem('token')
      axios.delete(
        `${GetBaseUrl()}/api/user/drop`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
        .then(response => {
          if (response && response.data) {
            alert(i18n.t('idsetting.delete.success'))
            Logout()
            this.props.history.push('/home')
            this.handleClose()
          }
        })
        .catch(e => {
          if (e && e.response && e.response.data) {
            const { message } = e.response.data

            if (message === 'EXIST_PAYMENT') alert(i18n.t('idsetting.delete.failed.exist.payment'))
            else alert(i18n.t('idsetting.delete.failed.unknown'))

            this.handleClose()
          }
          else {
            alert(i18n.t('idsetting.delete.failed.unknown'))
            this.handleClose()
          }
        })
    }
  }

  handleClose = () => this.setState({ isDialogOpeneDeleteAccount: false })
  handleOpenDialog = () => this.setState({ isDialogOpeneDeleteAccount: true })
  handleNoticeClose = () => this.setState({ isNoticeDialogopened: false })

  handleClickBusinessAccount = () => this.setState({ isOpenBusinessAccountDialog: true })
  handleClickCloseBusinessAccount = () => this.setState({ isOpenBusinessAccountDialog: false })
  
  handleOpenBlockDialog = () => this.setState({ isBlockDialogOpen: true })
  handleCloseBlockDialog = () => this.setState({ isBlockDialogOpen: false })

  isValidPassword = password => /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,32}$/.test(String(password).toLowerCase())

  render() {
    if (typeof this.props.currentUser === 'undefined') return null

    const { currentUser, paymentMode } = this.props
    const type = currentUser ? currentUser.type : null
    const { clickChangeName, createdAt, viewUserId, denyEmail, enableEmailNotifications, activatePermanently, userEmail, isOpenBusinessAccountDialog, isBlockDialogOpen } = this.state
    
    return (
      <div className="id-setting-root prohibit-drag">
        <div className="id-setting-container">
          <div className="layout">
            <h2 lang={this.props.value}>{i18n.t("accountsetting.component.name")}</h2>

            <div className="userInfo">
              <div className="list_flex_left">
                <div
                  className="list_header"
                  style={{ borderBottom: '1px solid #eee' }}
                >
                  <span>
                    <img src="https://front.videomonster.com/images-u6yd72dy/web/userinfoicon.png" alt="연결 아이콘" />
                  </span>
                  <span>{i18n.t("userinfo.title")}</span>
                </div>
                <div className="settingItem" style={{ borderTop: 'none' }}>
                  <div className="settingItem_left">
                    <p>{i18n.t("userinfo.name")}</p>
                    <p>
                      {clickChangeName ? (<input minlength={2} maxlength={16} type="text" value={viewUserId} placeholder={i18n.t("userinfo.enter.change.name.placeholder")} name="viewUserId"
                        onChange={this.handleChange}
                        autoComplete="off"
                      >
                      </input>

                      ) : viewUserId}
                    </p>
                  </div>
                  <div className="setting-btn-new">
                    <div >{clickChangeName ?
                      <p style={{ width: "100%" }} onClick={this.clickChangeName}>{i18n.t("global.confirm")}</p> :
                      <p style={{ width: "100%" }} onClick={this.clickedChangeName}>{i18n.t("userinfo.change.name")}</p>}
                    </div>
                  </div>
                </div>
                <div className="settingItem none_border ">
                  <div className="settingItem_left">
                    <p>{i18n.t("userinfo.email")}</p>
                    <p>{userEmail}</p>
                  </div>
                  <div className="setting-btn-new">
                    <div>
                      <p style={{ width: "100%" }} onClick={this.handleClickCopyInviteUserLink}>{i18n.t("idsetting.invite.user")}</p>
                    </div>
                  </div>
                </div>
                <div className="settingItem">
                  <div className="settingItem_left">
                    <p>{i18n.t("userinfo.date.when.signup")}</p>
                    <p>{`${dayjs(createdAt).year()}${i18n.t("userinfo.year")} ${dayjs(createdAt).month() + 1}${i18n.t("userinfo.month")} ${dayjs(createdAt).date()}${i18n.t("userinfo.day")}`}</p>
                  </div>
                  {
                    type !== 'business_partial' &&
                    <div className="setting-btn-new">
                      <div onClick={this.handleOpenDialog}>
                        <p style={{ width: "100%" }} >{i18n.t("idsetting.deleteaccount")}</p>
                      </div>
                    </div>
                  }
                </div>
                <div className="settingItem payment none_border" style={{ borderTop: 0 }}>
                  <div className="settingItem_left">
                    <p>
                      {i18n.t("payment.name")}
                    </p>
                    <p>{this.renderPaymentMode()}</p>
                    <p style={{ fontSize: "10px", color: "#828282" }}>{i18n.t("payment.subscribe.guide.text")}</p>
                    {(paymentMode && paymentMode.isCancelable === false && paymentMode.isInAppPurchase === false) && <p style={{ fontSize: "12px", color: "#000000" }}>{i18n.t("idsetting.recurring.payment.cancel.des")}</p>}
                  </div>
                  <div className="payment-area">
                    {this.renderPaymentModeButton()}
                  </div>
                </div>
                <div className="settingItem">
                  <div className="settingItem_left">
                    <p>{i18n.t("userinfo.block.user.management")}</p>
                    <p style={{ fontSize: "10px", color: "#828282" }}>{i18n.t("userinfo.block.user.management.description")}</p>
                  </div>
                  <div className="setting-btn-new">
                    <div onClick={this.handleOpenBlockDialog}>
                      <p style={{ width: "100%" }} >{i18n.t("userinfo.block.user.management.btn")}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="list_flex_right">
                {/* <div className="list_header pc-v" style={{ height: '27px' }} /> */}
                {/* <div className="settingItem">
                  <div className="settingItem_left">
                    <p>{i18n.t("userinfo.date.when.signup")}</p>
                    <p>{`${dayjs(createdAt).year()}${i18n.t("userinfo.year")} ${dayjs(createdAt).month() + 1}${i18n.t("userinfo.month")} ${dayjs(createdAt).date()}${i18n.t("userinfo.day")}`}</p>
                  </div>
                  <div className="settingButton settingButton1">
                    <div className="delte-account-button" onClick={this.handleOpenDialog}>
                      <p style={{ width: "100%" }} >{i18n.t("idsetting.deleteaccount")}</p>
                    </div>
                  </div>
                </div>
                <div className="settingItem none_border" style={{ borderTop: 0 }}>
                  <div className="settingItem_left">
                    <p>
                      {i18n.t("payment.name")}
                    </p>
                    <p>{this.renderPaymentMode()}</p>
                    <p style={{ fontSize: "10px", color: "#828282" }}>{i18n.t("payment.subscribe.guide.text")}</p>
                  </div>
                  <div className="settingButton settingButton1">
                    {this.renderPaymentModeButton()}
                    <div className="business-account-button" onClick={this.handleClickBusinessAccount}>
                      <p>{i18n.t("web.business.account.management")}</p>
                    </div>
                  </div>
                </div> */}
                {
                  type === 'local' &&
                  <>
                    <div
                      className="list_header"
                      style={{ borderBottom: '1px solid #eeeeee' }}
                    >
                      <span>
                        <img src="https://front.videomonster.com/images-u6yd72dy/web/passwordicon.png" alt="lock icon" />
                      </span>
                      <span>{i18n.t("userinfo.password.title")}</span>
                    </div>
                    <div className="settingItem-container">
                      <div
                        className="settingItem password"
                        style={{ borderBottom: 'none', borderTop: 'none' }}
                      >
                        <div className="settingItem_left">
                          <p>{i18n.t("userinfo.text.current.password")}</p>
                        </div>
                        <div className="setting-btn-new">
                          <input
                            type="password"
                            name="currentpassword"
                            onChange={this.handleChange}
                            value={this.state.currentpassword}
                            autoComplete="off"
                            maxLength={32}
                          />

                        </div>
                      </div>
                      <div className="settingItem none_border password">
                        <div className="settingItem_left">
                          <p>{i18n.t("userinfo.text.new.password")}</p>
                        </div>
                        <div className="setting-btn-new">
                          <input
                            type="password"
                            name="newpassword"
                            onChange={this.handleChange}
                            value={this.state.newpassword}
                            autoComplete="off"
                            maxLength={32}
                          />
                          <ErrorText textAlign={"center"} absolute={"absolute"} top="28px" margin={"3px 0 0 0"}>{this.isValidPassword(this.state.newpassword) || this.state.newpassword.length === 0 ? null : i18n.t("web.signup.password.wrong.text")}</ErrorText>
                        </div>
                      </div>
                      <div className="settingItem none_border password">
                        <div className="settingItem_left">
                          <p>{i18n.t("userinfo.text.again.check.password")}</p>
                        </div>
                        <div className="setting-btn-new">
                          <input
                            type="password"
                            name="confirmpassword"
                            onChange={this.handleChange}
                            value={this.state.confirmpassword}
                            autoComplete="off"
                            maxLength={32}
                          />
                          {this.state.confirmpassword.length === 0 ? <p ></p> :
                            <p
                              style={{
                                color: "red",
                                display: this.state.newpassword === this.state.confirmpassword ? 'none' : 'block',
                                fontSize: "12px",
                                marginTop: "3px"
                              }}
                              className="idSetting-password-double-check"
                            >
                              {i18n.t("signup.check.password")}
                            </p>
                          }
                        </div>
                      </div>
                      <div className="settingItem none_border password ">
                        {/* <div className="settingItem_left">
                        <p />
                      </div> */}
                        <div className="idSetting_longtext idSetting_longtext2">
                          {i18n.t("userinfo.alert.text.password1_1")}<span>{i18n.t("userinfo.alert.text.password1_2")}</span>{i18n.t("userinfo.alert.text.password1_3")}
                        </div>
                      </div>
                      <div className="settingItem none_border ">
                        <div className="settingItem_left">
                          <p />
                        </div>
                        <div className="setting-btn-new" onClick={this.changePassword}>
                          <div className="password">{i18n.t("userinfo.change.password")}</div>
                        </div>
                      </div>
                    </div>
                  </>
                }
                <div className="list_flex_right">
                  {/* 이메일 수신 동의 여부 */}
                  <div className="list_header " style={{ borderBottom: '1px solid #eeeeee' }}>
                    <span>
                      <img src="https://front.videomonster.com/images-u6yd72dy/web/emailIcon.png" alt="잠금 아이콘" />
                    </span>
                    <span>{i18n.t("userinfo.email.reception.title")}</span>
                  </div>

                  <div className="email-notification-wrap">
                    <div >
                      <p style={{ textAlign: "left", fontSize: "13px" }}>{i18n.t("userinfo.ask.email.reception.text")}</p>
                    </div>
                    <EmailNotification
                      labelPlacement={i18n.t("global.email")}
                      value={enableEmailNotifications + ""} // string 로 내려주려고 + "" 함
                      handleChange={this.changeEmailHandleChange}
                    />
                    <div >
                      <p style={{ textAlign: "left", fontSize: "13px" }}>{i18n.t("userinfo.email.reception.text")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Uploading open={this.state.isRefunding} progress={0}>{i18n.t("payment.ing.refund")}</Uploading>
          <Uploading open={this.state.isUnscheduling} progress={0}>{i18n.t("payment.ing.cancel")}</Uploading>

          {/* 회원탈퇴 dialog */}
          <DeleteAccountDialog
            // ButtonWidth = {"unset"}
            onDeleteClicked={this.handleDeleteAccount}
            cancleText={i18n.t("global.cancel")}
            deleteText={i18n.t("idsetting.confirmationdialog.deleteText1")}
            closeDialog={this.handleClose}
            isDialogOpened={this.state.isDialogOpeneDeleteAccount}
            title={i18n.t("idsetting.confirmationdialog.deleteTitle1")}
            message={i18n.t("idsetting.confirmationdialog.deleteMessage1")}
          />
          <OneBtnDialog
            open={this.state.isDialogOpened}
            closeBtn={this.dialogHandleClose}
            onButtonClick={this.dialogHandleClose}
            dialogType={this.state.dialogType}
          />
          {/* 환불신청 dialog */}
          <Notice
            open={this.state.isNoticeDialogopened}
            closeBtn={this.handleNoticeClose}
            paymentWay={this.state.paymentWay}
            onClickRefund={this.onClickRefund}
            onClickCancel={this.onClickCancel}
            checkUserWrited={this.checkUserWrited}
            active={this.state.active}
            refundReason={this.state.refundReason}
            onRefundReasonChanged={this.onRefundReasonChanged}
          />
          <BusinessAccount
            open={isOpenBusinessAccountDialog}
            onClose={this.handleClickCloseBusinessAccount}
          />
          <BlockUserListDialog
            open={isBlockDialogOpen}
            onClose={this.handleCloseBlockDialog}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  currentUser: state.userStore.user,
  paymentMode: state.paymentModeStore.paymentMode,
  pointTicket: state.pointTicketStore.pointTicket
})

export default connect(mapStateToProps, null)(IdSetting)